import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TenantService } from 'src/app/_service/tenant.service';
import { AuthService } from 'src/app/_service/auth.service';

import * as routing from '../../../_model/routing';
import { getTenantData, postTenantData } from 'src/app/_model/tenant'; 
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-tenant-list',
  templateUrl: './tenant-list.component.html',
  styleUrl: './tenant-list.component.css'
})
export class TenantListComponent {
  @Output() dataChange = new EventEmitter();
  @ViewChild('table', {read: ElementRef}) table!: ElementRef;
  tenantList: any = [];
  loading = true;
  constructor(
    private router: Router,
    private tenantService: TenantService,
    private translate: TranslateService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    public auth: AuthService,
  ) {
    // this.companyList = this.companyService.companyList;
  }
  tenantData!: postTenantData;
  tenantId ='';
  selected: any;
  private tenantListSubscription!: Subscription;

  ngOnInit(): void {
    if (this.tenantService.tenantList?.length === 0) {
      this.tenantService.getTenantList()
        .subscribe({
          next: async(value: any) => {
            this.tenantService.tenantList = value;
            this.tenantList = value;
            this.loading = false;
          },
        });
    } else {
      this.tenantList = this.tenantService.tenantList;
      this.loading = false;
    }
  }
  
  jumpCreateTenant() {
    this.router.navigate([routing.TenantRegistration]);
  }
  onButtonClick(selectedData: any) {
    this.tenantId = selectedData.id;
    this.tenantService.selectedTenantID = this.tenantId;
    const data = this.tenantList.find((e: any) => e.id === this.tenantService.selectedTenantID);
    if(data != undefined){
      this.addToTenantData(data);
    }
  }
  addToTenantData(data: getTenantData) {
    if (this.auth.isYakuin) {
      window.alert(this.translate.instant("noPermission"));
      return;
    }
    this.tenantData = {
      name: data.name,
      id: data.id,
      description: data.description,
      status_id: data.status_id,
      rbac: data.rbac,
      expiration_date: data.expiration_date,
    };
    this.tenantService.editTenantFlag = true;
    this.tenantService.editTenantData = this.tenantData;
    this.router.navigate([routing.TenantEdit]);
  }

  editTenantData(){
    // this.dialog.open(CompanyRegisterComponent,{width:'744px',height: '90vh'})
    //this.dialog.open(CompanyEditComponent,{width:'744px',height: '90vh'})
  }

  copyTenantId(id: string) {
    navigator.clipboard.writeText(id);

    this.translate.get("copyMsgTenant").subscribe((translatedText: string) => {
      this.snackBar.open(translatedText, "Close", {
        duration: 1300,
        panelClass: ["copy-msg"],
      });
    });
  }
 
  //unsubscribe for to avoid memory leak
  ngOnDestroy():void{
    if (this.tenantListSubscription) {
      this.tenantListSubscription.unsubscribe();
    }
  }
}
